import React from 'react';
import * as R from 'ramda';
import { FormattedMessage } from 'react-intl';
import { ColumnTree } from '../hooks/useTable/defineColumns';

export const PaymentTermColumn = ColumnTree.defineNode('payment-term', {
  predicate({ solutionColumns }) {
    return 'paymentterm' in solutionColumns && solutionColumns.paymentterm
      ? true
      : false;
  },
  make() {
    return {
      title: (
        <FormattedMessage
          id="marketplace-table-heading-paymentterm"
          defaultMessage="Payment term"
        />
      ),
      key: 'paymentterm',
      className: 'col-paymentterm',
      render: (text, record) => (
        <div className="td-content">
          {R.pathOr('', ['paymentterm', 'desc'], record)}
        </div>
      ),
    };
  },
});
